// Separate namespace keeps availability copy independent from page content.
export const maintenanceResources = {
  fr: {
    title: 'Une petite pause pour mieux vous retrouver',
    paused: 'Les demandes et la messagerie font une pause. Retour prévu vers {{time}}, heure du Maroc. Nos guides restent accessibles.',
    starting: 'Les services redémarrent. Vous pourrez bientôt reprendre vos projets.',
    unavailable: 'Les services prennent un peu plus de temps à répondre. Réessayez dans un instant ; vous pouvez continuer à parcourir nos guides.',
    offline: 'Votre connexion semble interrompue. Vérifiez votre accès à Internet pour retrouver les services.',
    retry: 'Vérifier', checking: 'Vérification…', guides: 'Parcourir les guides',
  },
  en: {
    title: 'A short break — see you soon',
    paused: 'Requests and messaging are taking a break. Back around {{time}}, Morocco time. Our guides remain available.',
    starting: 'Services are starting up. You can get back to your projects shortly.',
    unavailable: 'Services are taking a little longer to respond. Try again shortly; you can still browse our guides.',
    offline: 'Your connection appears to be offline. Check your Internet access to reconnect to services.',
    retry: 'Check again', checking: 'Checking…', guides: 'Browse guides',
  },
  ar: {
    title: 'استراحة قصيرة، نلتقي قريباً',
    paused: 'الطلبات والمراسلة في استراحة. العودة متوقعة حوالي {{time}} بتوقيت المغرب. تبقى أدلتنا متاحة.',
    starting: 'الخدمات تعود تدريجياً. ستتمكن قريباً من متابعة مشاريعك.',
    unavailable: 'تستغرق الخدمات وقتاً أطول للاستجابة. حاول بعد قليل؛ يمكنك مواصلة تصفح أدلتنا.',
    offline: 'يبدو أن اتصالك انقطع. تحقق من الإنترنت للعودة إلى الخدمات.',
    retry: 'تحقق مجدداً', checking: 'جارٍ التحقق…', guides: 'تصفح الأدلة',
  },
  darija: {
    title: 'Ra7a sghira, nrj3o likom 9rib',
    paused: 'Talabat w messages f ra7a. Rjou3 m3a {{time}}, b taw9it lmaghrib. Les guides ba9yin.',
    starting: 'Lkhedma katrj3 b chwiyya. T9der tkml machari3ek 9rib.',
    unavailable: 'Lkhedma katakhod chwiyya bach tjawb. 3awed jarrab, w t9der tchouf les guides.',
    offline: 'Kayban connexion t9t3at. Chouf Internet bach trj3 lkhedma.',
    retry: '3awed chouf', checking: 'Kanchoufo…', guides: 'Chouf les guides',
  },
  darija_ar: {
    title: 'راحة صغيرة، نرجعو ليكم قريب',
    paused: 'الطلبات والميساجات فراحة. الرجوع متوقع مع {{time}} بتوقيت المغرب. الأدلة ديالنا باقية متاحة.',
    starting: 'الخدمة كترجع بشوية. تقدر تكمل المشاريع ديالك قريب.',
    unavailable: 'الخدمة كتحتاج شوية باش تجاوب. عاود جرب، وتقدر تشوف الأدلة ديالنا.',
    offline: 'كيبان الكونكسيون تقطعات. شوف الإنترنت باش ترجع للخدمة.',
    retry: 'عاود شوف', checking: 'كنشوفو…', guides: 'شوف الأدلة',
  },
};
